import { useIntl } from 'react-intl'
import styled from 'styled-components'

import StatusLabel from 'LuxKit/Label/StatusLabel'

const StatusLabelWithPrintBorder = styled(StatusLabel)`
  @media print {
    &.kind-tertiary {
      border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
    }
  }
`

interface Props {
  className?: string
}

function BookedLabel({ className }: Props) {
  const intl = useIntl()
  return (
    <StatusLabelWithPrintBorder variant="confirmation" className={className}>
      {intl.formatMessage({
        id: 'g8wd_KQCS-NmJbZnpSL0',
        defaultMessage: 'Booked',
        description: 'Label indicating a trip item has been booked in the trip planner',
      })}
    </StatusLabelWithPrintBorder>
  )
}

export default BookedLabel
